import React, { useState } from "react";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import "./DateRenderer.scss";
import { label } from "../../../../config";
import { getUTCDate, keepUtcDate } from "../../../../helper/dateHelper";

/**
 * DateRenderer component for form date elements.
 * Parent component: FormRenderer
 * @author Abhishek Dhillon
 */
const DateRenderer = ({ element, onChange, showResponses = false, isGridElement }) => {
  const { properties = {}, value } = element ?? {};
  const {
    placeholder = label.SELECT_DATE_PLACEHOLDER,
    required = false,
    dateFormat = { label: "dd/MM/yyyy", value: "dd/MM/yyyy" },
    startDate = null,
    endDate = null,
    defaultValue = null,
    showChipName: showChipNameRaw,
  } = properties;
  const showChipName = showChipNameRaw === false ? false : true;

  const [dateValue, setDateValue] = useState(getUTCDate(value));

  /**
   * Returns the default date
   * @returns {Date} The default date
   * @author Abhishek Dhillon
   */
  const getDefaultDate = () => {
    if (defaultValue === "Current Date") {
      return keepUtcDate(new Date());
    }
    return undefined;
  };



  /**
   * Handles the change event for the DatePicker.
   * @param {Object} e - The event object
   * @returns {void}
   * @author Abhishek Dhillon
   */
  const handleChange = (e) => {
    const selectedDate = e?.value;
    const utcDate = keepUtcDate(selectedDate);
    setDateValue(utcDate);
    onChange && onChange(utcDate);
  };

  return (
    <div className={`date-renderer ${isGridElement ? "mb-0" : "mb-3"}`}>
      {showChipName && (
        <label htmlFor={`${element?.id}-date`} className='form-label'>
          {element?.name || label.DATE_FIELD}
        </label>
      )}
      <div className='d-flex'>
        <DatePicker
          placeholder={placeholder}
          value={dateValue}
          disabled={showResponses}
          format={dateFormat?.label}
          className='date-input'
          required={required}
          onChange={handleChange}
          defaultValue={getDefaultDate()}
          min={getUTCDate(startDate)}
          max={getUTCDate(endDate)}
        />
        {required && <span className='required-asterisk text-danger ms-1 ml-1'>*</span>}
      </div>
    </div>
  );
};

export default DateRenderer;
